import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk to fetch option chain data
export const fetchOptionChain = createAsyncThunk(
  'optionChain/fetchOptionChain',
  async ({ symbol, expiry }, { rejectWithValue }) => {
    try {
      console.log('Fetching option chain for symbol:', symbol, 'and expiry:', expiry);
      const token = sessionStorage.getItem('upstoxToken');
      if (!token) {
        throw new Error('No Upstox token found. Please add your token in the Upstox login page.');
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/upstox/option-chain`, {
        params: {
          instrument_key: symbol,
          expiry_date: expiry,
        },
        headers: {
          'Authorization': 'eyJ0eXAiOiJKV1QiLCJrZXlfaWQiOiJza192MS4wIiwiYWxnIjoiSFMyNTYifQ.eyJzdWIiOiI3TUFONzkiLCJqdGkiOiI2ODQ4MDViMTI1NDU5YTJlZGZlMWQzNjMiLCJpc011bHRpQ2xpZW50IjpmYWxzZSwiaXNQbHVzUGxhbiI6ZmFsc2UsImlhdCI6MTc0OTU1MDUxMywiaXNzIjoidWRhcGktZ2F0ZXdheS1zZXJ2aWNlIiwiZXhwIjoxNzQ5NTkyODAwfQ.J90ns03ndPkBMFWBUhArAqUGC7XnHxHAzm3DUGKH0u0'
        }
      });
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching option chain:', error);
      return rejectWithValue(error.response?.data || 'An error occurred while fetching data');
    }
  }
);

const optionChainSlice = createSlice({
  name: 'optionChain',
  initialState: {
    data: null,
    loading: false,
    error: null,
    strikePrices: [], // Add strikePrices to the state
  },
  reducers: {
    resetOptionChain: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.strikePrices = []; // Reset strike prices
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOptionChain.pending, (state) => {
        console.log('Fetching option chain data...');
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOptionChain.fulfilled, (state, action) => {
        console.log('Option chain data received:', action.payload);
        state.loading = false;
        state.data = action.payload;
        if (Array.isArray(action.payload.data)) {
          state.strikePrices = action.payload.data.map(item => item.strike_price);
          console.log('Extracted strike prices:', state.strikePrices);
        } else {
          console.log('No valid data array found in payload');
          state.strikePrices = [];
        }
      })
      .addCase(fetchOptionChain.rejected, (state, action) => {
        console.log('Error in option chain fetch:', action.payload);
        state.loading = false;
        state.error = action.payload || 'An error occurred';
      });
  },
});

export const { resetOptionChain } = optionChainSlice.actions;
export default optionChainSlice.reducer;
